import { render } from "./EmbedLink.vue?vue&type=template&id=4edccb20"
import script from "./EmbedLink.vue?vue&type=script&lang=js"
export * from "./EmbedLink.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__